import { render, staticRenderFns } from "./index.vue?vue&type=template&id=271bbf8a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=271bbf8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271bbf8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('271bbf8a')) {
      api.createRecord('271bbf8a', component.options)
    } else {
      api.reload('271bbf8a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=271bbf8a&scoped=true&", function () {
      api.rerender('271bbf8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/display-zone/index.vue"
export default component.exports